import React, { useState } from 'react';
import Navbar from '../layout/Navbar';
import { USER_SAVE_ENDPOINT } from '../../config/api';
import { decryptData } from '../../utils/encrypt';

function UserForm() {
  const encrypted = localStorage.getItem('suyog_user');
  const user = encrypted ? decryptData(encrypted) : { user_id: 0, user_token: '' };

  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    password: '',
    status: 1
  });

  const [message, setMessage] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);

    const payload = {
      ...form,
      created_by: user.user_id,     // ✅ Encrypted user ID
      user_token: user.user_token   // ✅ Encrypted token
    };

    try {
      const res = await fetch(USER_SAVE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage({ type: 'success', text: 'User created successfully' });
        setForm({ name: '', phone: '', email: '', password: '', status: 1 });
      } else {
        setMessage({ type: 'error', text: data.error || 'Save failed' });
      }
    } catch {
      setMessage({ type: 'error', text: 'Server error' });
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <h4>Create New User</h4>
        {message && (
          <div className={`alert alert-${message.type === 'success' ? 'success' : 'danger'}`}>
            {message.text}
          </div>
        )}
        <form onSubmit={handleSubmit} className="card p-4 shadow">
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input type="text" name="name" value={form.name} onChange={handleChange} className="form-control" required />
          </div>
          <div className="mb-3">
            <label className="form-label">Phone</label>
            <input type="text" name="phone" value={form.phone} onChange={handleChange} className="form-control" required />
          </div>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} className="form-control" />
          </div>
          <div className="mb-3">
            <label className="form-label">Password</label>
            <input type="password" name="password" value={form.password} onChange={handleChange} className="form-control" required />
          </div>

          {/* Preview payload (optional for dev) */}
          <div className="mb-3 text-end">
            <button
              type="button"
              className="btn btn-secondary me-3"
              onClick={() => alert(JSON.stringify({ ...form, created_by: user.user_id, user_token: user.user_token }, null, 2))}
            >
              Preview Payload
            </button>

            <button type="submit" className="btn btn-primary">
              <i className="bi bi-save me-2"></i>Save User
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default UserForm;
